<div class="container">
  <p class="title">
    Vessel Performance
    <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial
    Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Monthly
    Performance
  </p>
  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Monthly Report">
      <app-old-reports> </app-old-reports>
    </mat-tab>
    <mat-tab label="Custom Report">
      <app-generate-report #generateReports> </app-generate-report>
    </mat-tab>
  </mat-tab-group>
</div>
